(function($){
  "use strict";

  const behaviorOptions = {
    name: 'izzyScrollbarContent',
    selector: '.navbar',
  };

  function behavior(context, settings) {
    $(once(behaviorOptions.name, behaviorOptions.selector, context)).each(function(index, element) {
      window.izzyscrollbarcontent = new IzzyScrollbarContent(element);
    });
  }

  Drupal.behaviors[behaviorOptions.name] = {
    attach: function(context, settings){
      behavior(context, settings);
    },
  }

  // Init self in case we are loaded async.
  if (jQuery.isReady) {
    // It is up to script to define scope and settings it should be applied to
    // in case of jquery mobile integration used you can use site_common.jquery_mobile.getPageContext()
    // to get only current page's context.
    // In this example we use global scope.
    const context = document;
    const settings = Drupal.settings;
    Drupal.behaviors[behaviorOptions.name].attach(context, settings);
  }

    class IzzyScrollbarContent
    {
        constructor()
        {
            this.options =
            {
                SEL_MAIN:      '.scrollable',
                CLS_SCROLLBAR: 'scrollbar-content',
                BP_DESKTOP:    768
            };

            this.margin_right    = 0;
            this.scrollable_main = null;
            this.scrollbar =
            {
                main:   null,
                top:    null,
                thumb:  null,
                bottom: null
            };

            this.GetContentOffsetBottomDel  = this._GetContentOffsetBottom();
            this.GetFooterHeightDel         = this._GetFooterHeight();
            this.UpdateScrollablePaddingDel = this._UpdateScrollablePadding.call(this);
            this.OnScrollDel                = this._OnScroll.call(this);

            this.page_offset_bot = this.GetContentOffsetBottomDel();
            this.footer_height   = this._GetFooterHeight();

            this.Init();

        } // constructor

        Init()
        {
            this.scrollable_main = document.querySelector( this.options.SEL_MAIN );
            if( this.scrollable_main == null ) return;

            this.scrollable_main.appendChild( document.querySelector('footer') );

            // create/append scrollbar
            this._CreateScrollbar();

            // hiding original scrollbar
            this._HideOrigScroll();

            //
            this.UpdateScrollablePaddingDel();

            // scroll positioning
            this._UpdateFakeScrollPos();
            this._UpdateThumbHeight();
            this._UpdateThumbPos();

            this.scrollable_main.addEventListener( 'scroll', (e)=>{ this.OnScrollDel(e); } );
            window.addEventListener( 'resize', this._OnWinResize(this) );

            let _wheel_evnt = 'wheel';
            if( 'onwheel' in document ) // IE9+, FF17+, Ch31+
            {
                _wheel_evnt = 'wheel';
            }
            else if( 'onmousewheel' in document ) // OLD
            {
                _wheel_evnt = 'onmousewheel'
            }
            //window.addEventListener( _wheel_evnt, (e)=>{ this.OnWheelDel(e); } );

        } // Init

        _UpdateScrollablePadding()
        {
            let _services_main   = document.querySelector('.services__main');
            let _scrollable_main = document.querySelector( this.options.SEL_MAIN );

            return function()
            {
                if( _scrollable_main.offsetHeight < _scrollable_main.scrollHeight )
                {
                    _scrollable_main.style['padding-bottom'] = `${this._GetContentOffsetBottom()}px`;
                    _services_main.style['padding-bottom'] = 0;
                }

                if( window.innerWidth < 768 )
                {
                    _services_main.style['padding-bottom'] = null;
                }
            }

        } // _UpdateScrollablePadding

        _GetContentOffsetBottom()
        {
            let _block_main = document.querySelector('.services__main');

            return function()
            {
                return Math.abs( parseInt( getComputedStyle(_block_main).getPropertyValue('padding-bottom') ) );
            }

        } // _GetContentOffsetBottom

        _GetFooterHeight()
        {
            let _footer_block = document.querySelector('.footer__inner');

            return function()
            {
                return _footer_block.offsetHeight;
            }

        } // _GetFooterHeight

        _UpdateThumbHeight()
        {
            let _h = this.scrollable_main.offsetHeight / this.scrollable_main.scrollHeight * 100;
            this.scrollbar.thumb.style['height'] = `${_h}%`;

        } // _UpdateThumbHeight

        _UpdateThumbPos()
        {
            let _y = this.scrollable_main.scrollTop / this.scrollable_main.scrollHeight * 100;
            this.scrollbar.top.style['height'] = `${_y}%`;

        } // _UpdateThumbPos

        _OnScroll()
        {
            return function(e)
            {
                this._UpdateThumbHeight();
                this._UpdateThumbPos();
            }

        } // _OnScroll

        _OnWinResize(_self)
        {
            let _timeout = null;

            return (e)=>
            {
                clearTimeout(_timeout);

                if( ! this.scrollable_main instanceof Element ) return;
                if( window.innerWidth < _self.options.BP_DESKTOP ) return;

                _timeout = setTimeout(()=>{
                    // MAGIC
                    _self.page_offset_bot = _self.GetContentOffsetBottomDel();

                    _self.UpdateScrollablePaddingDel();
                    _self._UpdateFakeScrollPos();
                    _self._UpdateThumbHeight();
                    _self._UpdateThumbPos();

                }, 2);
            }

        } // _OnWinResize

        // scroll positioning
        _UpdateFakeScrollPos()
        {
            let _rect    = this.scrollable_main.getBoundingClientRect();
            let _padding = parseInt( getComputedStyle(this.scrollable_main).getPropertyValue('padding-right') );
            this.scrollbar.main.style['left'] = `${(_rect.left+_rect.width)-_padding}px`;

        } // _UpdateFakeScrollPos

        // hiding original scrollbar
        _HideOrigScroll()
        {
            this.margin_right = Math.max( this.scrollable_main.offsetWidth - this.scrollable_main.clientWidth, 0 );

        } // _HideOrigScroll

        _CreateScrollbar()
        {
            let _tmplt = `<div class="scrollbar-content">
              <div class="scrollbar-content__top" style="height: 10%"></div>
              <div class="scrollbar-content__thumb"></div>
              <div class="scrollbar-content__bottom" style="height: auto"></div>
            </div>`;

            document.body.insertAdjacentHTML( 'beforeend', _tmplt );

            this.scrollbar.main   = document.querySelector('.scrollbar-content');
            this.scrollbar.top    = this.scrollbar.main.querySelector('.scrollbar-content__top');
            this.scrollbar.thumb  = this.scrollbar.main.querySelector('.scrollbar-content__thumb');
            this.scrollbar.bottom = this.scrollbar.main.querySelector('.scrollbar-content__bottom');

            this.scrollbar.top.style['height'] = 0;

        } // _CreateScrollbar

    } // class IzzyScrollbarContent

})(jQuery);
